import useAjax from "@apis/useAjax";
import { useCallback } from "react";
import useShowPDF from "@util/hook/useShowPDF";
import {
	GET_DOC_MEMBERSHIP_QUIT_OPTIONS_API,
	GET_DOC_MEMBERSHIP_QUIT_HISTORY_API,
	GET_DOC_MEMBERSHIP_QUIT_ID_API,
	POST_MEMBERSHIP_QUIT_ID_API,
	DELETE_DOC_MEMBERSHIP_QUIT_ID_API,
	POST_DOC_MEMBERSHIP_QUIT_RANGE_FEE_API,
	GET_DOC_MEMBERSHIP_QUIT_TEMPORARY_API,
	POST_DOC_MEMBERSHIP_QUIT_TEMPORARY_API,
	DELETE_DOC_MEMBERSHIP_QUIT_TEMPORARY_API,
	GET_DOC_MEMBERSHIP_QUIT_TEMPLATE_PDF_API,
	GET_DOC_MEMBERSHIP_QUIT_CONTRACTID_INVALID_DIALOG_API,
	DELETE_DOC_MEMBERSHIP_CONTRACTID_API,
} from "@apis/apiPath";
import { checkResponse } from "@apis/utils";
import { isEmpty } from "@util/utils";

const useDocMembershipQuitApi = () => {
	const Ajax = useAjax();
	const showPDF = useShowPDF();

	// 取得退會申請書的下拉式選單
	const getDocMembershipQuitOptionApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_QUIT_OPTIONS_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員歷史紀錄(包含暫存)
	const getDocMembershipQuitHistoryApi = useCallback(
		async params => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_QUIT_HISTORY_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得退會會籍申請書內容
	const getDocMembershipQuitApi = useCallback(
		async (contractID, params) => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_QUIT_ID_API(contractID), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 新增/重填退會合約
	const postDocMembershipQuitApi = useCallback(
		async (contractID = 0, parameters) => {
			const resp = await Ajax.post(POST_MEMBERSHIP_QUIT_ID_API(contractID), parameters);
			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null; // 排除 0002 錯誤
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除退會申請書 TODO: 後續處理事項，尚未撰寫
	const deleteDocMembershipQuitApi = useCallback(
		async contractID => {
			const resp = await Ajax.delete(DELETE_DOC_MEMBERSHIP_QUIT_ID_API(contractID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 依輸入的內容重新計算日期及金額結果
	const postDocMembershipQuitRangeFeeApi = useCallback(
		async parameters => {
			const resp = await Ajax.post(POST_DOC_MEMBERSHIP_QUIT_RANGE_FEE_API, parameters);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 確認來源對象是否有暫存合約
	const getDocMembershipQuitTemporaryApi = useCallback(
		async params => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_QUIT_TEMPORARY_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 暫存退會申請書合約
	const postDocMembershipQuitTemporaryApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_DOC_MEMBERSHIP_QUIT_TEMPORARY_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除來源對象的暫存合約
	const deleteDocMembershipQuitTemporaryApi = useCallback(
		async params => {
			const resp = await Ajax.delete(DELETE_DOC_MEMBERSHIP_QUIT_TEMPORARY_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 下載空白PDF文件
	const getDocMembershipQuitTemplatePDFApi = useCallback(
		async () => {
			showPDF({
				open: true,
				pdfUrl: GET_DOC_MEMBERSHIP_QUIT_TEMPLATE_PDF_API,
			});
		},
		// eslint-disable-next-line
		[]
	);

	// 下載終止申請書(非空白)
	const getDocMembershipQuitPDFApi = useCallback(
		async contractUrl => {
			showPDF({
				open: true,
				pdfUrl: contractUrl,
			});
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除終止申請書初始資料
	const getDocMembershipQuitContractInvalidApi = useCallback(
		async contractID => {
			const resp = await Ajax.get(GET_DOC_MEMBERSHIP_QUIT_CONTRACTID_INVALID_DIALOG_API(contractID));
			if (checkResponse(resp)) {
				return resp;
			}
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除終止申請書
	const deleteDocMembershipQuitContractApi = useCallback(
		async (params, contractID) => {
			const resp = await Ajax.delete(DELETE_DOC_MEMBERSHIP_CONTRACTID_API(contractID), params);
			if (checkResponse(resp)) {
				return resp;
			}
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getDocMembershipQuitOptionApi,
		getDocMembershipQuitHistoryApi,
		getDocMembershipQuitApi,
		postDocMembershipQuitApi,
		deleteDocMembershipQuitApi,
		postDocMembershipQuitRangeFeeApi,
		getDocMembershipQuitTemporaryApi,
		postDocMembershipQuitTemporaryApi,
		deleteDocMembershipQuitTemporaryApi,
		getDocMembershipQuitTemplatePDFApi,
		getDocMembershipQuitPDFApi,
		getDocMembershipQuitContractInvalidApi,
		deleteDocMembershipQuitContractApi,
	};
};

export default useDocMembershipQuitApi;
